import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    Title,
    Tooltip,
    Legend,
    BarElement
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    BarElement,
    Title,
    Tooltip,
    Legend
);

function DashboardLineChart({ lineChartData }) {
    console.log("Line Chart Data:", lineChartData);
    let data = {};
    if (lineChartData.datasets) {
        data = {
            labels: lineChartData.labels,
            datasets: [
                {
                    label: lineChartData.datasets[0].label,
                    data: lineChartData.datasets[0].data,
                    borderColor: "#491ACB",
                    borderWidth: 0.5,
                    pointRadius: 10,
                },
                {
                    label: lineChartData.datasets[1].label,
                    data: lineChartData.datasets[1].data,
                    borderColor: "#491ACB",
                    borderWidth: 0.5,
                    pointRadius: 10,
                },
                {
                    label: lineChartData.datasets[2].label,
                    data: lineChartData.datasets[2].data,
                    borderColor: "#491ACB",
                    borderWidth: 0.5,
                    pointRadius: 10,
                }
            ]
        }
    } else {
        data = {
            labels: lineChartData.labels,
            datasets: [
                {
                    data: lineChartData.data,
                    borderColor: "#491ACB",
                    borderWidth: 0.5,
                    pointRadius: 10,
                    tension: 0, // curve
                },
            ],
        };
    }
    const options = {
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            title: { display: false, text: "Monthly Sales" },
        },
        scales: {
            x: {
                ticks: {
                    color: "#B6B6B6",  // X-axis label color
                    font: {
                        size: 14,      // X-axis font size
                        // weight: 'bold'
                    }
                }
            },
            y: {
                ticks: {
                    color: "#B6B6B6", // Y-axis label color
                    font: {
                        size: 14,     // Y-axis font size
                        // weight: 'bold'
                    }
                }
            }
        }
    };
    return (
        <div style={{ width: '980px', height: '580px' }}>
            <Bar data={data} options={options} />
        </div>
    );
}



export default DashboardLineChart
